module.exports = __webpack_public_path__ + "static/media/grid-background.jpeg?v=e6d0e850";